import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@ps-gui/shared-core';

@Injectable({
  providedIn: 'root',
})
export class PageApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  getImageForPage(pageId: string): Observable<Blob> {
    return this.get(`api/page/${pageId}/image`, {
      responseType: 'blob',
    });
  }

  loadThumbnails(batchId: string): Observable<Record<string, string>> {
    return this.get(`api/page/thumbnails?batchId=${batchId}`, {
      responseType: 'json',
    });
  }
}
